module.exports = __webpack_public_path__ + "img/horizontal-placeholder.2c0639a1.svg";